import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import { HomepageImageListRequestBody, HomepageImageListResponse } from "./types";

export class HomepageImageListAPI extends BaseAPI<
    HomepageImageListRequestBody,
    HomepageImageListResponse
> {
    protected route = ApiRoutes.home_image.list;
    protected method = RequestMethod.GET;
}
